(function () {
  'use strict';
  function init(root) {
    if (root.dataset.ready) return;
    root.dataset.ready = 'true';
    var inputs = Array.from(root.querySelectorAll('[data-bulk-quantity]'));
    var button = root.querySelector('[data-bulk-add]');
    var status = root.querySelector('[data-bulk-status]');
    var cartLink = root.querySelector('[data-bulk-cart]');
    if (!button) return;
    var busy = false;
    var eligible = root.dataset.discountEligible === 'true';
    var cartCount = 0;
    function countShirts(cart) {
      return (cart.items || []).reduce(function (sum, item) {
        return sum + (Number(item.product_id) !== 10147725115687 && /shirt/i.test(item.product_title || '') ? item.quantity : 0);
      }, 0);
    }
    try {
      var initialCart = document.getElementById('CartInsuranceInitial');
      if (initialCart) cartCount = countShirts(JSON.parse(initialCart.textContent));
    } catch (_) {}
    document.addEventListener('textual:cart-updated', function (event) {
      cartCount = countShirts(event.detail || {});
      if (!busy) update();
    });
    var money = new Intl.NumberFormat(document.documentElement.lang || 'en-US', {style:'currency', currency:root.dataset.currency});
    function selection() {
      var result = {items:[], count:0, total:0, valid:true};
      inputs.forEach(function (input) {
        if (input.disabled) return;
        var quantity = input.value === '' ? 0 : Number(input.value);
        if (!Number.isSafeInteger(quantity) || quantity < 0 || !input.validity.valid) { result.valid = false; return; }
        if (quantity) {
          result.items.push({id:Number(input.dataset.variantId), quantity:quantity});
          result.count += quantity;
          result.total += quantity * Number(input.dataset.price);
        }
      });
      return result;
    }
    function update() {
      var order = selection();
      root.querySelector('[data-bulk-total]').textContent = order.valid ? order.count + (order.count === 1 ? ' item — ' : ' items — ') + money.format(order.total / 100) + ' before discounts' : 'Enter whole-number quantities of 0 or more.';
      var count = cartCount + (eligible ? order.count : 0);
      var percent = eligible ? (count >= 4 ? 10 : count >= 2 ? 5 : 0) : 0;
      root.querySelectorAll('[data-bulk-tier]').forEach(function (tier) {
        var active = order.valid && order.count > 0 && Number(tier.dataset.bulkTier) === percent;
        tier.classList.toggle('is-active', active);
        tier.setAttribute('aria-current', active ? 'true' : 'false');
      });
      var saving = root.querySelector('[data-bulk-saving]');
      if (saving) {
        var discount = order.items.reduce(function (sum, item) {
          var input = inputs.find(function (node) { return Number(node.dataset.variantId) === item.id; });
          return sum + Math.floor(Number(input.dataset.price) * percent / 100) * item.quantity;
        }, 0);
        saving.textContent = !order.valid || !order.count ? '' : percent ? percent + '% off: estimated selection total ' + money.format((order.total - discount) / 100) + ' (save ' + money.format(discount / 100) + '). Based on ' + count + ' shirts including your cart. Final discounts confirmed in cart.' : eligible ? 'Add ' + Math.max(0, 2 - count) + ' more eligible shirt(s) to unlock 5% off.' : 'Shirt discounts do not apply to this item.';
      }
      button.disabled = busy || !order.valid || !order.count;
    }
    function selectInitialZero(event) {
      var input = event.target;
      if (inputs.includes(input) && !input.disabled && input.value === '0') input.select();
    }
    root.addEventListener('focusin', selectInitialZero);
    root.addEventListener('click', selectInitialZero);
    root.addEventListener('beforeinput', function (event) {
      var input = event.target;
      // Mobile number inputs may not keep a text selection. Replace the zero
      // immediately before digit entry, while leaving untouched fields at zero.
      if (inputs.includes(input) && !input.disabled && input.value === '0' &&
          event.inputType.indexOf('insert') === 0 && /^\d+$/.test(event.data || '')) {
        input.value = '';
      }
    });
    root.addEventListener('input', update);
    root.addEventListener('keydown', function (event) {
      if (event.key === 'Enter' && event.target.matches('[data-bulk-quantity]')) { event.preventDefault(); if (!button.disabled) button.click(); }
    });
    button.addEventListener('click', async function () {
      var order = selection();
      if (busy || !order.valid || !order.count) return;
      var form = root.closest('form');
      if (form && !form.reportValidity()) return;
      // Shared personalization fields, when present, belong to every selected shirt.
      if (form) {
        var properties = {};
        new FormData(form).forEach(function (value, key) {
          var match = key.match(/^properties\[(.+)\]$/);
          if (match && typeof value === 'string') properties[match[1]] = value;
        });
        if (Object.keys(properties).length) order.items.forEach(function (item) { item.properties = properties; });
      }
      busy = true; update();
      var enabled = inputs.filter(function (input) { return !input.disabled; });
      enabled.forEach(function (input) { input.disabled = true; });
      status.textContent = 'Adding your selection…';
      cartLink.hidden = true;
      var route = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
      var added = false;
      try {
        var response = await fetch(route + 'cart/add.js', {method:'POST',headers:{'Content-Type':'application/json','Accept':'application/json'},body:JSON.stringify({items:order.items})});
        var data = await response.json();
        if (!response.ok) throw new Error(data.description || data.message || 'Could not add this selection.');
        added = true;
        enabled.forEach(function (input) { input.value = '0'; });
        status.textContent = order.count + (order.count === 1 ? ' item added to your cart.' : ' items added to your cart.');
        cartLink.hidden = false;
      } catch (error) {
        status.textContent = (error.message || 'Could not confirm the cart update.') + ' Check your cart before trying again.';
        cartLink.hidden = false;
      }
      // Reconcile even on failure: Shopify can adjust stock quantities before returning an error.
      try {
        var cartResponse = await fetch(route + 'cart.js', {headers:{Accept:'application/json'},cache:'no-store'});
        if (!cartResponse.ok) throw new Error('cart');
        var cart = await cartResponse.json();
        document.dispatchEvent(new CustomEvent('textual:insurance-cart-updated', {detail:cart}));
        document.dispatchEvent(new CustomEvent('textual:cart-updated', {detail:cart}));
        if (added) document.dispatchEvent(new CustomEvent('textual:cart-open', {detail:cart}));
      } catch (_) {
        if (added) status.textContent += ' Open your cart to review the updated total.';
      } finally {
        enabled.forEach(function (input) { input.disabled = false; });
        busy = false; update();
      }
    });
    update();
  }
  document.querySelectorAll('[data-bulk-order]').forEach(init);
  document.addEventListener('shopify:section:load', function (event) { event.target.querySelectorAll('[data-bulk-order]').forEach(init); });
}());
